import { BaseApiService } from './BaseApiService'

export interface AutoTopupPaymentMethod {
  id: string
  type: string
  cardBrand: string
  cardDisplay: string
}

export interface AutoTopupConfig {
  enabled: boolean
  thresholdCents: number
  amountCents: number
  paymentMethod?: AutoTopupPaymentMethod
  lastTriggeredAt?: string
}

export interface UpdateAutoTopupConfigParams {
  enabled: boolean
  thresholdCents: number
  amountCents: number
  paymentMethodId: string
  maxRetries?: number
}

/**
 * Auto Top-Up API Service
 *
 * Handles API calls related to automatic balance top-up configuration
 */
export class AutoTopupApiService extends BaseApiService {
  private readonly basePath = '/account/auto-topup'

  async getConfig(): Promise<AutoTopupConfig> {
    return this.get<AutoTopupConfig>(this.basePath, { requiresAuth: true })
  }

  async updateConfig(config: UpdateAutoTopupConfigParams): Promise<void> {
    await this.post<{ success: boolean }>(this.basePath, config, { requiresAuth: true })
  }

  async disableAutoTopup(): Promise<void> {
    await this.delete<{ success: boolean }>(this.basePath, { requiresAuth: true })
  }
}

// Singleton instance
export const autoTopupApiService = new AutoTopupApiService()

import { queryOptions } from '@tanstack/react-query'

export const autoTopupQueries = {
  all: ['auto-topup'] as const,

  config: () => queryOptions({
    queryKey: [...autoTopupQueries.all, 'config'] as const,
    queryFn: () => autoTopupApiService.getConfig(),
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  }),
}
